<app-splash class="z-1000"></app-splash>

<header id="app-header"></header>

<mat-sidenav-container class="grow flex! flex-col overflow-visible! bg-surface-dim">
  <mat-sidenav #appSidenav fixedInViewport
               id="app-sidenav"
               position="start"
               class="top-16! bg-surface">
    <app-primary-sidebar></app-primary-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="grow flex! flex-col overflow-visible!">
    <router-outlet class="hidden [&+*]:flex-1"></router-outlet>

    <div></div>

    <mat-divider></mat-divider>

    <footer id="app-footer"></footer>

  </mat-sidenav-content>
</mat-sidenav-container>